import { MatSnackBar } from '@angular/material/snack-bar';
import { ToolbarService } from 'src/app/core/services/toolbar.service';
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { HandsetService } from '../../../core/services/handset.service';
import { availableExtensions, UploadedFile } from '../../models/uploaded-file.model';
import { LiabilityScanService } from '../../services/liability-scan.service';
import { finalize, switchMap, take } from 'rxjs/operators';

@Component({
standalone: false,
  selector: 'app-add-liability-scan',
  styleUrls: ['./add-liability-scan.component.scss'],
  templateUrl: './add-liability-scan.component.html',
})
export class AddLiabilityScanComponent implements OnDestroy {
  public files: UploadedFile[] = [];
  public error: string;
  public uploading = false;
  public disabled = false;

  constructor(
    public handsetService: HandsetService,
    private router: Router,
    private route: ActivatedRoute,
    private toolbar: ToolbarService,
    private snackbar: MatSnackBar,
    private liabilityScanService: LiabilityScanService,
  ) {
    this.toolbar.init(this.route);
  }

  ngOnDestroy(): void {
    this.files.forEach((file: UploadedFile) => this.liabilityScanService.revokeFileUrl(file));
  }

  public addDroppedFile = (files: NgxFileDropEntry[]): void => {
    const file = files[0];

    if (file.fileEntry.isFile) {
      const fileEntry = file.fileEntry as FileSystemFileEntry;
      fileEntry.file((f: File) => {
        this.addFilesToList({ fileData: f });
      });
    }
  };

  public filesAdded = (event: Event): void => {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    let files = [];
    for(let n = 0; n< fileList.length; n++){
      files.push(fileList.item(n));
    }
    if (files) {
      const file = { fileData: files[0] };
      this.addFilesToList(file);
    }
  };

  private addFilesToList = (file: UploadedFile): void => {
    this.removeDropAreaClass();
    this.disabled = false;
    this.error = null;
    this.setFileExtension(file);
    const fileSize = Math.round(file.fileData.size / 1024);

    if (fileSize > 5120) {
      this.error = 'Maksymalny rozmiar pliku to 5MB.';
    } else if (availableExtensions.indexOf(file.extension) < 0) {
      this.error = 'Obsługiwane formaty pliku to PDF, JPG, JPEG, PNG.';
    } else {
      file.url = this.liabilityScanService.getFileUrl(file);
      file.urlSafe = this.liabilityScanService.getFileUrlSafe(file);

      this.files.push(file);
      this.files = [...this.files]; //force change detection
      this.showSuccessfullyUploadedInfo();
    }
  };

  public uploadDocumentsForAutomaticReading = (): void => {
    if (this.files.length === 0) {
      this.error = 'Dodaj plik PDF, JPG, JPEG lub PNG.';
      this.disabled = true;
    } else {
      this.uploading = true;
      this.liabilityScanService
        .uploadDocumentsForAutomaticReading(this.files.map((f) => f.fileData))
        .pipe(
          take(1),
          switchMap((automaticReadingId: string) => this.router.navigate([`/liabilities/reading/${automaticReadingId}`])),
          finalize(() => (this.uploading = false)),
        )
        .subscribe();
    }
  };

  public remove = (index: number): void => {
    this.files.splice(index, 1);
  };

  public showDropArea(): void {
    this.addDropAreaClass();
  }

  public hideDropArea(): void {
    this.removeDropAreaClass();
  }

  public async checkPermissions(file: HTMLInputElement): Promise<void> {
    // @ts-ignore
    if (typeof mobileFun === 'function') {
      try {
        // @ts-ignore
        await mobileFun().then((hasCameraPermissions) => {
          if (hasCameraPermissions) {
            file.click();
          }
        });
      } catch (err) {
        console.log(err);
      }
    } else {
      file.click();
    }
  }

  private showSuccessfullyUploadedInfo() {
    // @ts-ignore
    if (typeof mobileOnSuccessFun === 'function') {
      try {
        // @ts-ignore
        mobileOnSuccessFun();
      } catch (err) {
        console.log(err);
      }
    } else {
      // this.snackbar.open('Plik został pomyślnie dodany', 'Zamknij', { duration: DURATION_5S });
    }
  }

  private addDropAreaClass(): void {
    this.getFileAreaElement()?.classList.add('file-drop-area');
  }

  private removeDropAreaClass(): void {
    this.getFileAreaElement()?.classList.remove('file-drop-area');
  }

  private getFileAreaElement(): HTMLElement {
    return document.getElementById('file-area');
  }

  private setFileExtension(file: UploadedFile): void {
    const splitByDots = file.fileData.name.split('.');
    file.extension = splitByDots[splitByDots.length - 1].toLowerCase();
  }
}
